import { render, staticRenderFns } from "./add-urge-order.vue?vue&type=template&id=10c55c5c&scoped=true&"
import script from "./add-urge-order.vue?vue&type=script&lang=js&"
export * from "./add-urge-order.vue?vue&type=script&lang=js&"
import style0 from "./add-urge-order.vue?vue&type=style&index=0&id=10c55c5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c55c5c",
  null
  
)

export default component.exports